export const USER_CREATE_LOADING = 'USER_CREATE_LOADING'
export const USER_CREATE_COMPLETE = 'USER_CREATE_COMPLETE'
export const USER_CREATE_ERROR = 'USER_CREATE_ERROR'

export const VERIFY_PHONE_NUMBER_LOADING = 'VERIFY_PHONE_NUMBER_LOADING'
export const VERIFY_PHONE_NUMBER_COMPLETE = 'VERIFY_PHONE_NUMBER_COMPLETE'
export const VERIFY_PHONE_NUMBER_ERROR = 'VERIFY_PHONE_NUMBER_ERROR'

export const LOGIN_LOADING = 'LOGIN_LOADING'
export const LOGIN_COMPLETE = 'LOGIN_COMPLETE'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const SET_TOKEN = 'SET_TOKEN'

export const SET_REDIRECT_AFTER_AUTH = 'SET_REDIRECT_AFTER_AUTH'
export const CLEAR_REDIRECT_AFTER_AUTH = 'CLEAR_REDIRECT_AFTER_AUTH'

export const RESET_PASSWORD_LOADING = 'RESET_PASSWORD_LOADING'
export const RESET_PASSWORD_COMPLETE = 'RESET_PASSWORD_COMPLETE'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/auth/mutation-types.js
// module id = null
// module chunks = 